// extracted by mini-css-extract-plugin
module.exports = {"aboutPageContainer":"styles_aboutPageContainer__3z03O","workManImg":"styles_workManImg__3Y5iK","fontIcon":"styles_fontIcon__7GR6L"};